import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CourseTopic } from "../response/Course_Topic_Response";
import { Recommendation } from "../response/VideoLandingPageResponse";

type TopicIndex = number | string | null;

interface LearningRoomState {
  topicDetailedIndex: TopicIndex;
  selectedItem: CourseTopic | null; //topic selected item
  courseSelectedItem: Recommendation | null;
  labClick: boolean;
}

const initialState: LearningRoomState = {
  topicDetailedIndex: null,
  selectedItem: null,
  courseSelectedItem: null,
  labClick: false,
};

const learningRoomSlice = createSlice({
  name: "learningRoom",
  initialState,
  reducers: {
    setLRSelectedItem(state, action: PayloadAction<CourseTopic | null>) {
      state.selectedItem = action.payload;
    },

    setLRTopicDetailedIndex(state, action: PayloadAction<TopicIndex>) {
      state.topicDetailedIndex = action.payload;
    },
    setLRLabClick(state, action: PayloadAction<boolean>) {
      state.labClick = action.payload;
    },

    setLRCourseSelectedItem(
      state,
      action: PayloadAction<Recommendation | null>,
    ) {
      state.courseSelectedItem = action.payload;
    },

    clearLRState(state) {
      return initialState;
      //   state.topicDetailedIndex = initialState.topicDetailedIndex;
      //   state.selectedItem = initialState.selectedItem;
      //   state.courseSelectedItem = initialState.courseSelectedItem;
    },
  },
});

export const {
  setLRSelectedItem,
  setLRTopicDetailedIndex,
  setLRCourseSelectedItem,
  clearLRState,
  setLRLabClick,
} = learningRoomSlice.actions;

export default learningRoomSlice.reducer;
